var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Rest } from "../../Rest";
export class PvsApiLegacy extends Rest {
    constructor(baseUrl, tenantToken) {
        super(baseUrl);
        this.tenantToken = tenantToken;
        this.name = "PvsApi";
        this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
    }
    verifyOtp(phoneVerificationUuid, code) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(`/verify-by-uuid/${phoneVerificationUuid}`, {
                body: JSON.stringify({ code }),
                method: "PUT",
            }, true);
        });
    }
    /***
     * @deprecated
     * only used in the dead code at this point in time - might be removed in the future
     */
    verifyEmailOtp(uuid, code) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.request(`/verify-by-uuid/${uuid}`, {
                body: JSON.stringify({ code }),
                method: "PUT",
            }, true);
            return response;
        });
    }
    checkVerificationStatus(uuid, hash) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request(`/status/${uuid}/${hash}`, {
                method: "GET",
            });
        });
    }
    initPhoneValidationByOtp(phone) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.request("/init-phone-validation", {
                method: "POST",
                body: JSON.stringify({ phone }),
            }, true);
        });
    }
}
//# sourceMappingURL=PvsApiLegacy.js.map